import Index from './index'
import Listar from './Listar'
import Detalhes from './Detalhes'
import Novo from './Novo'
import Editar from './Editar'

const route = {
  path: '/parametros',
  name: 'parametros',
  component: Index,
  children: [
    { path: 'listar', name: 'parametros-listar', component: Listar },
    { path: 'novo', name: 'parametros-novo', component: Novo },
    { path: ':id', name: 'parametros-detalhes', component: Detalhes, props: true },
    { path: ':id/e', name: 'parametros-editar', component: Editar, props: true }
  ],
  meta: { requiresAuth: true }
}

export default route



// WEBPACK FOOTER //
// ./src/pages/parametros/routes.js